/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 15H8.9L19.2 4.7l-1.4-1.4L5.1 16l12.7 12.7 1.4-1.4L8.9 17H28z"/>'
  }
})
